var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "m14 3l6 4v7m-2 3l-6 4l-6-4m-2-3V7l6-4" }),
      createElementVNode("path", { d: "m4 7l8 5v9m8-14l-8 5" })
    ], -1)
  ]));
}
__name(render, "render");
const brandUnity = markRaw({ name: "tabler-brand-unity", render });
export {
  brandUnity as default
};
//# sourceMappingURL=brand-unity.js.map
